import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { EditPencil } from 'iconoir-react'
import { useRef, useState } from 'react'
import MetricCell from './MetricCell'

export default function EditableCell({
  originalValue,
  type = `unitless`,
  onSave,
}: {
  originalValue?: string
  type?: `unitless` | `dollars`
  onSave: (value?: string) => Promise<void>
}) {
  const [value, setValue] = useState(originalValue)
  const [isEditing, setIsEditing] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const toggleEdit = () => setIsEditing((prev) => !prev)
  const onCancelClick = () => {
    setValue(originalValue)
    if (inputRef.current) {
      inputRef.current.value = originalValue ?? ``
      inputRef.current.blur()
    }
    toggleEdit()
  }
  return (
    <div
      className={classNames(`group flex h-full cursor-default px-2`, isEditing && `border border-blue-600`)}
      style={isEditing ? { backgroundColor: `var(--primary-alpha-8)` } : undefined}
    >
      <div className="relative flex w-full grow items-center justify-between">
        {isEditing ? (
          <>
            <input
              autoFocus
              //   type={type}
              ref={inputRef}
              className="grow bg-transparent"
              defaultValue={value}
              onChange={(e) => setValue(e.target.value)}
            />
            <div className="absolute right-0 flex items-center">
              <div
                className="flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded border bg-surface-subtle p-1.5"
                onClick={() => onCancelClick()}
              >
                <XMarkIcon className="stroke-current text-strong" />
              </div>
              <div
                className="ml-1 flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded border bg-blue-600 p-1.5"
                onClick={async () => {
                  setIsSaving(true)
                  toggleEdit()
                  await onSave(value)
                  setIsSaving(false)
                }}
              >
                <CheckIcon className="stroke-current text-on-color" />
              </div>
            </div>
          </>
        ) : (
          <>
            <MetricCell value={value ? +value : undefined} type={type} />
            <button
              disabled={isSaving}
              className="invisible flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded border bg-surface-subtle p-1.5 group-hover:visible"
              onClick={!isSaving ? () => toggleEdit() : undefined}
            >
              <EditPencil className="text-default" />
            </button>
          </>
        )}
      </div>
    </div>
  )
}
